import {
  selectCurrentHotelName,
  selectLoggedinUserEmail,
  selectLoggedinUserName,
  selectLoggedinUserPhone
} from 'accessors'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const Crisp = () => {
  const userEmail = useSelector(selectLoggedinUserEmail)
  const userPhone = useSelector(selectLoggedinUserPhone)

  const userName = useSelector(selectLoggedinUserName)
  const isUserLoggedIn = useSelector(s => s.login.userLoggedIn)
  const currentHotelName = useSelector(selectCurrentHotelName)

  const csmEmail = useSelector(s => s.hotelDetails.csmEmail)

  useEffect(() => {
    if (isUserLoggedIn && window.$crisp) {
      try {
        window.$crisp.push(['set', 'user:email', [userEmail]])
        window.$crisp.push(['set', 'user:nickname', [userName]])

        if (currentHotelName) {
          window.$crisp.push(['set', 'user:company', [currentHotelName]])
        }

        if (userPhone) {
          window.$crisp.push(['set', 'user:phone', [userPhone]])
        }
      } catch (e) {
        console.warn(e)
      }
    }
  }, [userEmail, userPhone, isUserLoggedIn, userName, currentHotelName])

  useEffect(() => {
    if (csmEmail && window.$crisp) {
      try {
        window.$crisp.push(['set', 'session:data', [[['csm-email', csmEmail]]]])
      } catch (e) {
        console.warn(e)
      }
    }
  }, [csmEmail])

  return null
}

export default Crisp
